import React from 'react'
import { Label, Paragraph } from 'atoms/Texts'
import { NotifItem, NotifUnreadDot } from './styles'
import { notifRouteHelper } from 'helpers/notifNavigateHelper'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { updateReadNotifs } from 'Redux/actions/NotifActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'

const NotifListItem = ({ item, fnSwitch, theme, history: { push }, updateReadNotifs }) => {
  const { title, body, createdAt, readAt, type, action, id: notifId } = item
  const { id: itemId } = action
  const fullRoute = notifRouteHelper(type, itemId)

  const handleClick = () => {
    updateReadNotifs(notifId)
    push(fullRoute)
    fnSwitch()
  }

  return (
    <NotifItem onClick={() => handleClick()}>
      {!readAt &&
        <NotifUnreadDot />
      }
      <Label color={theme.mocaOrange}>
        {title}
      </Label>
      <Paragraph>
        {body}
      </Paragraph>
      <Label float={'right'} lineheight={'12px'} size={'10px'} weight={'400'} color={theme.mocaGreen} mb={'0'}>
        {moment(createdAt).fromNow()}
      </Label>
    </NotifItem>
  )
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateReadNotifs
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      null,
      mapDispatchToProps
    )(NotifListItem)
  )
)
